import { useEffect, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import Table from "../../../../../../../../common/components/table-manager/v1.1/table";
import PageLoader from "../../../../../../../../components/PageLoader";
import { useAppDispatch } from "../../../../../../../../hooks/hooks";
import { useSelector } from "react-redux";
import { selectListItems } from "../../../../../../../../redux/library/selector";
import { dbaPublishLogs } from "../../../../../../../../redux/dba-publish-logs/action";
import { selectDBAPublishLogsListItems } from "../../../../../../../../redux/dba-publish-logs/selector";

const DBAPublishLogs = ({ selectedDba }: any) => {
  const dispatch = useAppDispatch();
  const navigate = useNavigate();
  const { id: bizId } = useParams();
  const [pageData, setPageData] = useState(1)
  const [pageSize, setPageSize] = useState(10);
  const dbaPublishLogsListItems = useSelector(selectDBAPublishLogsListItems)
  const libraryData = useSelector(selectListItems)
  const [columnDefs, setColumnDefs] = useState({});

  const createColumnDefs: any = () => {
    setColumnDefs([
      {
        field: 'Sl',
        sortable: false,
        filter: false,
        isSortLabel: true,
        headerName: 'Sl',
        cellRenderer(params: any) {
          return parseInt(
            params.node.id,
            10
          ) + 1;
        },
      },
      { field: 'DBNBizType', headerName: 'DBNBiz Type', sortable: true, filter: true, filterType: 'text' },
      { field: 'TotalProductsPublished', headerName: 'Total Products Published', sortable: true, filter: true, filterType: 'text' },
      { field: 'TotalUpdatedProductsPublished', headerName: 'Total Updated Products Published', sortable: true, filter: true, filterType: 'text' },
      { field: 'TotalProductsFailed', headerName: 'Total Products Failed', sortable: true, filter: true, filterType: 'text' },
      { field: 'CatalogVersion', headerName: 'Catalog Version', sortable: true, filter: true, filterType: 'text' },
      {
        field: 'PublishTypeId',
        headerName: 'Publish Type',
        cellRenderer: 'libraryRendererComponent',
        cellRendererParams: { library: libraryData?.result?.PublishType },
        sortable: true,
        filter: true,
        filterType: 'text',
        filterBy: libraryData?.result?.PublishType,
        align: 'text-center'
      },
      {
        field: 'TriggerSourceId',
        headerName: 'Trigger Source',
        cellRenderer: 'libraryRendererComponent',
        cellRendererParams: { library: libraryData?.result?.TriggerSource },
        sortable: true,
        filter: true,
        filterType: 'text',
        filterBy: libraryData?.result?.TriggerSource,
        align: 'text-center'
      },
      { field: 'LastPublishedDateOnUtc', headerName: 'Last Published On', isDateValueFormat: true, },
    ]);
  }

  const fetchDBAPublishLogsList = async () => {
    await dispatch(dbaPublishLogs.resetAction({ actionType: 'list' }))
    await dispatch(dbaPublishLogs.list({
      url: `https://catalog.digiit.${process.env.REACT_APP_API_URL}/api/v6.1/catalog/catalog-publish-tracker/fetch`,
      entity: 'dbaPublishLogs',
      jsonData:
      {
        Context: {},
        Records: [
          {
            DBAId: selectedDba?.DBAId,
          }
        ],
        Pagination: {
          PageNumber: pageData,
          PageSize: pageSize,
          SortField: "Id",
          SortOrder: "desc",

        }
      }
    }))
  }

  const additionButtons: any = [
    {
      svg:
        <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" width="24" height="24">
          <title>Reload this table</title>
          <path d="M21 3V8M21 8H16M21 8L18 5.29168C16.4077 3.86656 14.3051 3 12 3C7.02944 3 3 7.02944 3 12C3 16.9706 7.02944 21 12 21C16.2832 21 19.8675 18.008 20.777 14" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" />
        </svg>,
      callback: () => handleReloadData(),
    },
  ];

  const handleReloadData = () => {
    fetchDBAPublishLogsList();
  };

  const handleEditPublishLogs = (data: any) => {
    navigate(`/management/dbn-cloud/dbas/${bizId}/catalog-logs/publish-logs/${data?.CatalogPublishTrackerId}`);
  }

  const handleSearch = async (data: any) => {
    let searchCriteria = {};
    if (data?.column) {
      searchCriteria = [{
        FieldName: data?.column || data?.searchCriteriaList,
        FieldText: data?.column || data?.searchCriteriaList,
        FieldType: 'text',
        FilterOperatorId: data?.filterOperatorId || 6,
        FieldValue: data?.value
      }]
    } else {
      searchCriteria = [{
        FieldName: "Name",
        FieldText: "Name",
        FieldType: 'text',
        FilterOperatorId: 6,
        FieldValue: data?.value
      }]
    }
    await dispatch(dbaPublishLogs.resetAction({ actionType: 'list' }))
    await dispatch(dbaPublishLogs.list({
      url: `https://catalog.digiit.${process.env.REACT_APP_API_URL}/api/v6.1/catalog/catalog-publish-tracker/fetch`,
      entity: 'dbaPublishLogs',
      jsonData:
      {
        Context: {},
        Records: [
          {
            DBAId: selectedDba?.DBAId,
          }
        ],
        Pagination: {
          PageNumber: pageData,
          PageSize: pageSize,
          SortField: "Id",
          SortOrder: "desc",
          Searches: searchCriteria,
        }
      }
    }));
  }

  useEffect(() => {
    createColumnDefs();
    fetchDBAPublishLogsList();
  }, [pageData, pageSize])

  return (
    <>
      {dbaPublishLogsListItems?.isLoading ? <PageLoader /> :
        <Table
          columnData={columnDefs}
          rowData={dbaPublishLogsListItems?.result?.items}
          setPageData={setPageData} setPageSize={setPageSize}
          paginationData={dbaPublishLogsListItems?.result?.pagination}
          enableFilter={true} onSearch={handleSearch}
          checkboxConfig={{
            allowMultiSelect: true,
            defaultSelectedIds: [],
            isDisabled: false,
            keyColumn: 'Id',
          }}
          additionButtons={additionButtons} onEdit={handleEditPublishLogs}
          headingName="DBA Publish Logs"
        />
      }
    </>
  );
};

export default DBAPublishLogs;


